/**
 * B-07 tolerante lezer: accepteert zowel de oude kale lijst als de nieuwe
 * `ListResponse`-envelop ({items, total, ...}). Vormen zonder `items`-key
 * (zoals subcategories' Record) passeren ongewijzigd — dat is permanent
 * gedrag, geen tijdelijke shim.
 */
export function unwrapList<TList>(data: unknown): TList {
  if (data && typeof data === 'object' && !Array.isArray(data) && 'items' in data) {
    return (data as { items: TList }).items
  }
  return data as TList
}
